import React from "react";
import s from "./Header.module.scss";

function Header() {
  return (
    <div className={s.welcomeTab}>
      <h2 className={s.title}>Account</h2>
      <p className={s.subtitle}>Manage your account here</p>
    </div>
  )
}

export default Header;
